import { render, staticRenderFns } from "./addBid.vue?vue&type=template&id=b4c99c9e&scoped=true"
import script from "./addBid.vue?vue&type=script&lang=js"
export * from "./addBid.vue?vue&type=script&lang=js"
import style0 from "./addBid.vue?vue&type=style&index=0&id=b4c99c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c99c9e",
  null
  
)

export default component.exports